
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'AddressFooter'
})
export default class AddressFooter extends Vue {}
